if(!customElements.get('newsletter-popup')){
    class NewsletterPopup extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.form = this.querySelector('.newsletter-form');
            this.buttonSubmit = this.querySelector('input[type="submit"]');

            // close popup
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.closePopup.bind(this));
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter' || e.key === ' '){
                        e.preventDefault();
                        this.closePopup();
                    }
                });
            });
            this.addEventListener('click', e => {
                if(e.target === this) this.closePopup();
            });
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE') this.closePopup();
            });

            // submit
            this.form.addEventListener('submit', this.submitForm.bind(this));

            // adjust top margin
            if(this.dataset.verticalPosition === 'top'){
                this.adjustTopPosition();
                window.addEventListener('scroll', () => {
                    this.adjustTopPosition();
                });
            }

            // open popup
            if(window.location.pathname == '/challenge'){
                this.delay = 10;
            }
            this.delay = this.delay? this.delay : parseInt(this.dataset.delay);
            this.popupClosed = getCookie('newsletter-closed');

            setTimeout(() => {
                if(this.popupClosed !== null) return;
                if(sessionStorage.getItem('newsletter-popup-open') == 'true') return; // display once per session
                this.openPopup();
            }, this.delay);

            // open newsletter popup by clicking button
            document.querySelectorAll('.button-newsletter').forEach(item => {
                const action = item.dataset.action;
                const object = item.dataset.object;

                if(action == 'open' && object == 'newsletter-popup'){
                    item.addEventListener('click', (e) => {
                        this.openPopup(e, item);
                    });

                    if(getCookie('newsletter-button-closed') !== 'true'){
                        item.setAttribute('data-hidden', 'false');
                        item.removeAttribute('inert');
                    }
                }
            });
        }

        adjustTopPosition(){
            const header = document.querySelector('custom-header');
            const utilityBar = document.querySelector('custom-utility-bar');

            if(header){
                var topPosition = 0;
                
                const topScroll = utilityBar? utilityBar.clientHeight : 0;
                const currentScroll = window.scrollY;

                const sticky = header.dataset.sticky;
                const scroll = header.dataset.scroll;
                const scrollTop = header.dataset.scrollTop;

                if(sticky == 'scroll-up' && scroll == 'false' && scrollTop == 'false'){
                }else if(sticky == 'none' && scroll == 'true'){
                }else{
                    topPosition = header.offsetHeight;

                    if(scroll !== 'true' && utilityBar){
                        topPosition += utilityBar.offsetHeight;
                    }

                    if(sticky == 'none' && currentScroll > topScroll){
                        topPosition = 0;
                    }
                }

                this.style.top = `${topPosition}px`;
            }
        }

        openPopup(e = null, triggerElement = null) {
            if(e !== null){
                e.preventDefault();

                const currentElem = e.target;
                let buttonClose;
                if(currentElem.classList.contains('button-close')){
                    buttonClose = currentElem.classList.contains('button-close');
                }else if(currentElem.closest('.button-close')){
                    buttonClose = currentElem.closest(".button-close");
                }

                if(buttonClose){
                    const buttonNewsletter = buttonClose.closest('.button-newsletter');

                    buttonNewsletter.setAttribute('data-hidden', 'true');
                    buttonNewsletter.setAttribute('inert', '');
                    setCookie('newsletter-button-closed', 'true');
                    return;
                }
            }

            this.previouslyFocusedElement = triggerElement || document.activeElement;

            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');
            sessionStorage.setItem('newsletter-popup-open', 'true');

            this.addFocus();

            document.querySelectorAll('.button-newsletter').forEach(item => {
                const action = item.dataset.action;
                const object = item.dataset.object;

                if(action == 'open' && object == 'newsletter-popup'){
                    item.setAttribute('data-hidden', 'true');
                    item.setAttribute("inert", '');
                }
            });
        }

        addFocus(){
            if(this.form){
                setTimeout(() => {
                    this.form.querySelector('.input-email')?.focus();
                }, 100);
            }
        }

        closePopup(){
            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');
            setCookie('newsletter-closed', 'true');

            document.querySelectorAll('.button-newsletter').forEach(item => {
                const action = item.dataset.action;
                const object = item.dataset.object;

                if(action == 'open' && object == 'newsletter-popup'){
                    item.setAttribute('data-hidden', 'false');
                    item.removeAttribute('inert');
                }
            });

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        submitForm(e){
            if(window.Shopify.recaptchaV3) return;
            if(this.buttonSubmit.getAttribute('disabled') == 'disabled') return;

            this.buttonSubmit.setAttribute('disabled', 'disabled');
        }
    }

    customElements.define('newsletter-popup', NewsletterPopup);
}